import { HomeComponent } from './components/home/home.component';
import { MapRefiningComponent } from './components/map/map.component';
import { LoginComponent } from './login/login.component';
import { AuthenticationGuard} from './core/auth/guards/authentication-gaurd';
import { AuthorizationAdminGuard} from './core/authorization/authorization-admin-gaurd';
import { AuthorizationMarketerGuard } from './core/authorization/authorization-marketer-guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { UsersListComponent } from './users/users-list.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthenticationGuard],
  },
  { path: 'login', component: LoginComponent },
  {
    path: 'id_token',
    component: LoginComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'interactive_map',
    component: MapRefiningComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    // To evaluator directly, all components are loading in single component
    path: 'evaluator',
    canActivate: [AuthenticationGuard],
    canActivateChild: [AuthenticationGuard],
    loadChildren: 'app/value-tracker/value-tracker.module#ValueTrackerModule',
  },
  {
    path: 'users',
    component: UsersListComponent,
    canActivate: [AuthenticationGuard, AuthorizationAdminGuard]
  },
  {
    path: '**',
    component : PageNotFoundComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/app.routing.ts